/* unplugin-vue-components disabled */import { render } from "./CallsComponent.vue?vue&type=template&id=042ba644&scoped=true"
import script from "./CallsComponent.vue?vue&type=script&lang=js"
export * from "./CallsComponent.vue?vue&type=script&lang=js"

import "./CallsComponent.vue?vue&type=style&index=0&id=042ba644&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042ba644"]])

export default __exports__